<button type="button" [class.isChecked]="numOfFilters > 0">
  Filters

  <ng-container *ngIf="numOfFilters"> ({{ numOfFilters }} applied) </ng-container>

  <i class="material-icons">chevron_right</i>
</button>
